import { gql, useMutation } from '@apollo/client'

export const DELETE_USER = gql`
  mutation($id: Int!) {
    deleteUser(id: $id) {
      id
    }
  }
`

export const useDeleteUser = () => {
  const [mutate, { data, loading, error }] = useMutation(DELETE_USER, {
    update(cache) {
      cache.modify({
        fields: {
          listUsers() {}
        }
      })
    }
  })

  return { mutate, data, loading, error }
}
